import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { memberShares } from '@/mocks/home';

export default function ShareSection() {
  return (
    <section id="share" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="会员分享"
          title="听听会员怎么说"
          desc="这些是社区成员的真实使用感受。他们来自不同领域，但都在这里整理出了属于自己的资源库。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {memberShares.map((member, index) => (
            <Reveal key={member.name} delay={index * 60}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-center gap-3">
                  <span
                    className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 font-heading text-base font-semibold text-accent-900"
                    aria-hidden="true"
                  >
                    {member.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-950">{member.name}</p>
                    <p className="text-xs text-foreground-500">{member.role}</p>
                  </div>
                </div>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  「{member.content}」
                </p>
                <p className="mt-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  {member.meta}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}